import React from 'react';

import Modal from './Modal';

const ModalLoading = (props: {
	icon: string;
	description: string;
	cancelButtonRef: React.MutableRefObject<null>;
	isShowModal: boolean;
	closeModalBackground: () => void;
	onClick?: () => void;
}) => {
	return (
		<Modal
			cancelButtonRef={props.cancelButtonRef}
			isShowModal={props.isShowModal}
			closeModalBackground={props.closeModalBackground}
		>
			<div className="flex justify-center items-center mb-3">
				<img src={props.icon} className="w-6 h-6" />
			</div>
			<div>
				<p className="laptop:text-large tablet:text-large mobile:text-regular text-gray-gray600 font-interRegular">
					{props.description}
				</p>
			</div>
			<button ref={props.cancelButtonRef} />
		</Modal>
	);
};

export default ModalLoading;
